import React, { useState, useEffect } from "react";
import Head from "next/head";
import Container from "../../components/Container";
import Router from "next/router";
// import CouponBox from "./RegistrationComponents/CouponBox";
import RegistrationBox from "./RegistrationComponents/RegistrationBox";
import CouponBox from "./RegistrationComponents/SubComponents/CartBox/CouponBox";
import Navbar from "../../components/NavigationBar/Navbar";
import { getEventDetails, getEventTickets, getWaitlist } from "./../../crud/checkout.crud";
import { errorToaster, encodeTicketFormNames, decodeTicketFormNames } from "../../helpers/utils";
import MobileNavBar from "./../../components/NavigationBar/MobileNavbar";
import moment from "moment-timezone";
import { checkTeamBasedRegStatus, convertTimezone } from "../../helpers/common";
import { baseUrl } from "../../config/config";
import TippyIcon from "../../components/TippyIcon";
import AuthContext from "../../contexts/AuthContext";
import { handleLogout } from "../../common/Functions";
import { useContext } from "react";
import ProfileCard from "../../components/NavigationBar/ProfileCard";
import RegistrationTimer from "./RegistrationComponents/SubComponents/RegistrationTimer";
import { countryCode } from "../../helpers/services";
import { motion } from "framer-motion";
import TicketExpired from "./RegistrationComponents/SubComponents/TicketExpired";
import _ from "lodash";

const CheckoutPage = ({ query, isReady, eventData }) => {
	const authContext = useContext(AuthContext);
	const [eventDetails, setEventDetails] = useState(eventData);
	const [ticketDetails, setTicketDetails] = useState("");
	const [groupDiscounts, setGroupDiscounts] = useState([]);
	const [totalActiveRegs, setTotalActiveRegs] = useState(0);
	const [waitlistDetails, setWaitlistDetails] = useState("");
	const [isLoading, setIsLoading] = useState(true);

	const [formRules, setFormRules] = useState("");

	const [openPaymentModal, setOpenPaymentModal] = useState(false);
	const [ticketExpired, setTicketExpired] = useState(false); // 0 -> is not expired, 1 -> expired, 2 -> access code purchased, 3 -> coming soon

	const [selectedTickets, setSelectedTickets] = useState([]); // Getting the tickets for registration timer

	/*  curComp (currentComponent): 0 -> PickTickets.js, 1 -> AttendeeDetails.js, 2 -> ReviewTickets.js */
	const [curComp, setCurComp] = useState(0);
	const [isBackClicked, setIsBackClicked] = useState(false);
	const [teamRegStatus, setTeamRegStatus] = useState(0); // 0 -> No team based tickets, 1 -> Only team based tickets, 2 -> team based and individual tickets
	const [teamRegType, setTeamRegType] = useState(false); //false -> not selected, 0 -> individual tickets, 1 -> Create team, 2 -> Join Team
	const [isEventPageTeamComp, setIsEventPageTeamComp] = useState(false); //if ticket is team based and hidden and user clicked on team based component in event page

	useEffect(() => {
		if (isReady && query.eventUrl)
			fetchDetails(query.eventUrl, query.booking_id, query.referred_by, query);
		else if (isReady && !query.eventUrl) Router.push("/error");

		setIsEventPageTeamComp(sessionStorage.getItem("isEventPageTeamComp") ? true : false)
	}, [isReady]);

	const fetchDetails = async (url, bookingId, referred_by, query) => {
		const isReferral = referred_by ? true : false;
		let waitlistTicket = false;
		if (bookingId) {
			waitlistTicket = await getWaitlistDetails(url, bookingId, query.ticket_id);
		}
		await getTicketDetails(url, waitlistTicket, isReferral, query);
	};

	const getTicketDetails = async (url, waitlistTicket, isReferral, query) => {
		const error = "Something went wrong, please try again later";
		// if (ticketDetails) setTicketDetails("") //Set to empty before api call
		try {
			setIsLoading(true);
			const ticketRes = await getEventTickets(url, isReferral);
			setGroupDiscounts(ticketRes.data.group_discount_details);
			setTotalActiveRegs(
				ticketRes.data.total_active_registrations
					? ticketRes.data.total_active_registrations
					: 0
			);
			const uncategorized = ticketRes.data.uncategorized;
			let ticketDetails = [...uncategorized];
			ticketRes.data.categorized = ticketRes.data.categorized.sort(
				(a, b) => a.category_order - b.category_order
			);
			ticketRes.data.categorized.forEach(category => {
				category.tickets = category.tickets.map(ticket => {
					ticket.category = {
						category_name: category.category_name,
						category_description: category.category_description,
						category_id: category.category_id,
						category_order: category.category_order,
						is_expanded: category.is_expanded
					};
					return ticket;
				});
				ticketDetails = [...ticketDetails, ...category.tickets];
			});
			// let ticketDetails = ticketRes.data.uncategorized;
			const newTicketDetails = [];
			ticketDetails.forEach(ticket => {
				ticket.final_price = ticket.ticket_price;
				if (
					waitlistTicket && //If waitlist is approved, add a field to recognize in ticketSummary.js for payment button
					ticket.waitlist_enabled &&
					waitlistTicket.ticket_id === ticket.ticket_id
				) {
					ticket.waitlist_done = true;
				}
				if (!ticket.hidden_ticket) newTicketDetails.push(ticket);
				else if (
					(query.ticketId === "6259" && ticket.ticket_id === 6259) ||
					(query.ticketId === "6437" && ticket.ticket_id === 6437) ||
					(query.ticketId === "6533" && ticket.ticket_id === 6533) ||
					(query.ticketId === "6627" && ticket.ticket_id === 6627) ||
					(query.ticketId === "6629" && ticket.ticket_id === 6629) ||
					(query.ticketId === "6630" && ticket.ticket_id === 6630) ||
					(query.ticketId === "6662" && ticket.ticket_id === 6662)
				)
					newTicketDetails.push(ticket);
			});
			const teamRegistrationStatus = !_.isEmpty(query) && query?.teamRegType && query?.isAccessCode // if ticket is hidden and team_based
				? query.teamRegType : checkTeamBasedRegStatus(newTicketDetails);
			if (teamRegistrationStatus > 0) checkIfTeamSelected(teamRegistrationStatus);
			if (!_.isEmpty(query) && query?.teamRegType === "0" && query?.isAccessCode) {
				//if hidden ticket, team based enabled and individual is selected in team based component in event page
				setTeamRegType(0);
			}
			setTeamRegStatus(teamRegistrationStatus);
			setTicketDetails(encodeTicketFormNames(newTicketDetails));
			setFormRules(ticketRes.data.form_rules);
			setIsLoading(false);
		} catch (err) {
			console.log(err);
			errorToaster(error);
			setIsLoading(false);
		}
	};

	const checkIfTeamSelected = teamRegistrationStatus => {
		if (teamRegistrationStatus) {
			const teamName = sessionStorage.getItem("team_name");
			const teamId = sessionStorage.getItem("team_id");
			const teamLeadName = sessionStorage.getItem("team_lead_name");
			const teamLeadEmail = sessionStorage.getItem("team_lead_email");
			if (query.team_name && query.team_id) {
				if (!!teamName && !!teamId) {
					setTeamRegType(2);
					setCurComp(0);
				} else setCurComp(3);
			} else if (query.team_name && query.team_lead_email && query.team_lead_name) {
				if (!!teamName && !!teamLeadName && !!teamLeadEmail) {
					setTeamRegType(1);
					setCurComp(0);
				} else setCurComp(3);
			} else if (query.teamRegType === "0") {
				setTeamRegType(0);
				setCurComp(0);
			} else {
				setCurComp(3);
			}
		}
	};

	const getWaitlistDetails = async (eventUrl, bookingId, ticketId) => {
		const error =
			"Something went wrong with your waitlist payment link, please try again later";
		try {
			const waitlistRes = await getWaitlist(
				eventUrl,
				bookingId,
				query.is_waitlist ? query.is_waitlist : true,
				ticketId
			);
			const waitlistDetails = waitlistRes.data.waitlist_details;
			setWaitlistDetails(decodeTicketFormNames([waitlistDetails]));
			return waitlistDetails;
		} catch (err) {
			console.log(err);
			setTicketExpired(2);
			// errorToaster(error);
		}
	};

	const handleBackBtn = () => {
		switch (curComp) {
			case 0:
				if (teamRegStatus === 0) Router.push(`${baseUrl}/${eventData.event_url}`);
				else {
					setCurComp(3);
					setTeamRegType(false);
				}
				break;
			case 1:
				if (query.booking_id) Router.push(`${baseUrl}/${eventData.event_url}`);
				else setIsBackClicked(true); // setCurComp(0);
				break;
			case 2:
				setCurComp(1);
				break;
			case 3:
				Router.push(`${baseUrl}/${eventData.event_url}`);
				break;
			default:
				break;
		}
	};

	const localTimeZone = moment.tz.guess();
	const event_start_timestamp = convertTimezone(
		`${eventData.start_date} ${eventData.start_time}`,
		localTimeZone
	);
	const event_end_timestamp = convertTimezone(
		`${eventData.end_date} ${eventData.end_time}`,
		localTimeZone
	);


	const date = {
		start_month: moment.utc(event_start_timestamp).local().format("MMM Do"),
		end_month: moment.utc(event_end_timestamp).local().format("MMM Do"),
		start_day: moment.utc(event_start_timestamp).local().format("ddd"),
		end_day: moment.utc(event_end_timestamp).local().format("ddd"),
		start_year: moment.utc(event_start_timestamp).local().format("YYYY"),
		end_year: moment.utc(event_end_timestamp).local().format("YYYY"),
		start_time: moment.utc(event_start_timestamp).local().format("h:mm A"),
		end_time: moment.utc(event_end_timestamp).local().format("h:mm A"),
		timezone: moment.tz(event_end_timestamp, localTimeZone).format("z"),
	};

	return (
		<>
			{ticketExpired == 0 ? (
				<>
					<Head>
						<link rel="icon" href="./favicon/globe.ico" />
					</Head>
					<div className="checkout-container">
						{/* <Navbar color={'#000'} mobileNavbar={false}/> */}
						{/* {authContext.signedIn ? (<div className="checkout-header-container pt-2 mb-2 d-md-flex d-none">
                    <ProfileCard onLogout={(e) => handleLogout(e, authContext)} className="profile-class" />
                </div>) : <div className="pt-5 d-md-flex d-none"></div>} */}
						{/* Displayed only on bigger screens */}
						<div className="pt-4 d-md-flex d-none"></div>
						<div className="container-fluid d-flex px-3 px-xl-5 mb-3 py-3 py-md-0 event-title-bg flex-wrap d-md-flex d-none">
							<div className="back-btn-cont d-md-block d-none text-center">
								<TippyIcon content="Go Back">
									{/* <button className="event-page-btn mx-auto no-button-outline" C>

                                <img src="/img/checkout/back-btn.svg" />
                            </button> */}
									<motion.button
										className="event-page-btn mx-auto no-button-outline position-relative"
										style={{
											background: query.secondaryBg
												? `#${query.secondaryBg}`
												: `#EFE9ED`,
											border: query.borderCl
												? `2px solid #${query.borderCl}`
												: `2px solid #b79fb1`
										}}
										whileHover={{
											scale: 1.2,
											color: "#fff",
											backgroundColor: query.btnBg
												? `#${query.btnBg}`
												: `#fb5850`,
											transition: { duration: 0.1 }
										}}
										whileTap={{ scale: 0.9, transition: { duration: 0.1 } }}
										onClick={handleBackBtn}
									>
										{/* <img src="/img/checkout/back-btn.svg" /> */}
										<motion.i
											className="fa-solid fa-arrow-left position-absolute w-100 h-100 d-flex align-items-center justify-content-center"
											style={{
												top: "0px",
												left: "0px",
												fontSize: "24px",
												color: query.btnBg ? `#${query.btnBg}` : `#fb5850`
											}}
											whileHover={{
												scale: 1.1,
												color: "#fff",
												transition: { duration: 0.1 }
											}}
										></motion.i>
									</motion.button>
								</TippyIcon>
							</div>
							<div>
								<h3 className="mb-3">{eventData.name}</h3>
								<img src={"/img/calendarIcon.svg"} className="mb-1"></img>
								<span className="ms-3">
									{`${date.start_month}, ${date.start_year}`}
									&nbsp;at&nbsp;
									{date.start_time} {date.timezone}
									&nbsp;to&nbsp;
									{`${date.end_month}, ${date.end_year}`}
									&nbsp;at&nbsp;
									{date.end_time} {date.timezone}
								</span>
							</div>
							{curComp !== 0 && curComp !== 3 && (
								<div className="d-flex d-none d-md-block justify-content-center align-items-center ms-auto mt-auto timer-count-container text-end me-2">
									<RegistrationTimer
										url={`${baseUrl}${Router.router.asPath}`}
										openPaymentModal={openPaymentModal}
										query={{}}
										selectedTickets={selectedTickets}
										eventDetails={eventDetails}
										className="d-inline-block timer-count mt-auto px-2 pt-1"
									/>
								</div>
							)}
						</div>
						<div className="container-fluid pdx-0 px-md-3 px-lg-3 px-xl-5">
							<div className="row mx-0">
								<div className="col-sm-12 col-md-12 pdx-0">
									<RegistrationBox
										eventDetails={eventDetails}
										ticketDetails={ticketDetails}
										isLoading={isLoading}
										setTicketDetails={setTicketDetails}
										setTicketExpired={setTicketExpired}
										getTicketDetails={getTicketDetails}
										query={query}
										isWidget={false}
										groupDiscounts={groupDiscounts}
										totalActiveRegs={totalActiveRegs}
										waitlistDetails={waitlistDetails}
										curComp={curComp}
										setCurComp={setCurComp}
										isBackClicked={isBackClicked}
										setIsBackClicked={setIsBackClicked}
										setSelectedTickets={setSelectedTickets}
										setWaitlistDetails={setWaitlistDetails}
										handleBackBtn={handleBackBtn}
										openPaymentModal={openPaymentModal}
										setOpenPaymentModal={setOpenPaymentModal}
										teamRegStatus={teamRegStatus}
										teamRegType={teamRegType}
										setTeamRegType={setTeamRegType}
										formRules={formRules}
										setFormRules={setFormRules}
										setTeamRegStatus={setTeamRegStatus}
										isEventPageTeamComp={isEventPageTeamComp}
										setIsEventPageTeamComp={setIsEventPageTeamComp}
									/>
								</div>
							</div>
						</div>
						{/* <MobileNavBar /> */}
						<style jsx global>{`
							.back-btn-cont {
								width: 115px;
							}
							.checkout-container {
								min-height: 70vh;
								height: auto;
								background: #fff;
							}
							.bg-1 {
								background: url("/img/checkout/checkout-bg-1.svg") no-repeat;
								position: absolute;
								background-position: top left 15%;
								z-index: 0;
							}
							.bg-2 {
								background: url("/img/checkout/checkout-bg-2.svg") no-repeat;
								position: absolute;
								background-position: bottom -60px right 50px;
								z-index: 0;
							}
							.back-btn-checkout-mobile {
								background: transparent;
							}
							.no-button-outline {
								border: none;
								outline: none;
							}
							.event-page-btn {
								border-radius: 100%;
								width: 60px;
								height: 60px;
								transition: 0.3s all;
							}

							// .event-page-btn:hover {
							//     background: #fb5850;
							// }

							.checkout-header-container {
								height: ${authContext.signedIn ? "30px" : "10px"};
								justify-content: end;
							}

							.event-page-btn:hover img {
								filter: brightness(0) invert(1);
							}

							.profile-class {
								display: inline-block;
								float: right;
								right: 20px;
							}

							@media (min-width: 768px) and (max-width: 991px) {
								.timer-count-container {
									width: 100%;
									margin-top: 1rem !important;
								}
							}

							@media (max-width: 768px) {
								.checkout-container {
									height: auto;
									background: white;
								}
								.bg-2 {
									display: none;
								}
								.bg-1 {
									background-size: contain;
								}
								.checkout-header-container {
									height: 50px;
								}
								.event-title-bg {
									background: white;
									border-radius: 10px;
									width: 95%;
								}
								.pdx-0 {
									padding-left: 0px !important;
									padding-right: 0px !important;
								}
							}
						`}</style>
					</div>{" "}
				</>
			) : (
				<TicketExpired
					type={ticketExpired}
					goBack={() => {
						window.location.href = `${baseUrl}/checkout/${Router.router.query.eventUrl}`;
					}}
					eventName={eventDetails.name}
					eventTemplate={eventDetails.event_template}
				/>
			)}
		</>
	);
};

export default CheckoutPage;
